import React from 'react'
import './inputfield.css'
import useInputValidation from '../../hooks/useInputValidation'
import { InputFieldPropsInterface } from '../../utils/constants/Interfaces.constants'

const InputField: React.FunctionComponent<InputFieldPropsInterface> = ({
    labelFor = "",
    label,
    type = 'text',
    value,
    onChangeInput,
    name,
    required = false,
    maxLength,
    minLength,
    pattern,
    className = "",
    placeholder,
    disabled = false,
    underlinedInput = false,
    containerClassName = '',
    showErrors = true
}) => {

    const { bindValue } = useInputValidation()

    const underlineStyle = underlinedInput === true ? "mf-admin-inputfield-underlined" : " "

    return (
        <div className={"mf-admin-inputfield-container " + containerClassName}>
            {
                label?.length !== 0 &&
                <label className='text-primary-color weight-400 text-capitalize mf-admin-inputfield-label mb-1' htmlFor={labelFor}>{label}</label>
            }
            <input
                className={'mf-admin-inputfield ' + className + ` ${underlineStyle}`}
                name={name}
                type={type}
                value={value}
                onChange={onChangeInput}
                required={required}
                minLength={minLength}
                maxLength={maxLength}
                pattern={pattern}
                placeholder={placeholder}
                disabled={disabled}
                {...bindValue(name)}
            />

            {
                value.length === 0 && showErrors === true &&
                <p className="mb-0 error-msg weight-500">field is required</p>
            }
            {
                minLength && showErrors === true &&
                value.length !== 0 && value.length < minLength &&
                <p className="mb-0 error-msg weight-500">Input can't have less than {minLength}</p>
            }
            {
                typeof minLength === 'number' && showErrors === true &&
                <>
                    {
                        value.length >= minLength && type !== 'password' && !value.match(/pattern$/) &&
                        <p className="mb-0 error-msg weight-500">Invalid input values</p>
                    }
                    {
                        value.length >= minLength && type === 'password' && !value.match(/pattern$/) &&
                        <p className="mb-0 error-msg weight-500">Password should contain atleast 1 letter, 1 number and 1
                            special character</p>
                    }
                </>
            }
        </div>
    )
}

export default InputField